// 多语言翻译文件
export const translations = {
  'zh-CN': {
    // 导航
    nav: {
      home: '首页',
      about: '关于我们',
      services: '核心服务',
      advisory: '顾问委员会',
      news: '公司动态',
      cases: '成功案例',
      contact: '联系我们',
    },
    // 首页
    home: {
      hero: {
        title: '人月双清 传世基业',
        subtitle: 'SHONCHIN MANOR & CO.',
        description: '为亚洲企业在阿联酋构建数字孪生镜像主体，实现全球化运营与资产保护。',
        cta: '立即咨询',
        learnMore: '了解服务',
      },
      stats: {
        title: '核心优势',
        subtitle: '深耕中阿跨境商业咨询15年，服务超过200家中国企业',
        clients: '服务企业',
        assets: '资产管理',
        success: '成功率',
        countries: '国家覆盖',
      },
      services: {
        title: '核心服务',
        subtitle: '四大核心业务板块，为您提供全方位的跨境商业咨询服务',
        viewAll: '查看全部服务',
      },
      trust: {
        title: '信任背书',
        subtitle: '获得国际权威机构认证，值得信赖的跨境商业伙伴',
        dmcc: 'DMCC官方ISP',
        dmccDesc: '国际服务商资质',
        difc: 'DIFC认证',
        difcDesc: '金融中心认证',
        iso: 'ISO 9001',
        isoDesc: '质量管理体系',
        aml: 'AML合规',
        amlDesc: '反洗钱认证',
      },
      cta: {
        title: '开启您的全球化之旅',
        description: '无论您是寻求海外市场拓展的企业，还是需要资产保护的家族，双清团队都将为您提供专业、可靠的跨境商业咨询服务。',
        button: '预约咨询',
      },
      about: {
        title: '深植百年家学',
        titleHighlight: '构建数字主权',
        description: '承袭1897年双清楼历史底蕴，为亚洲企业在阿联酋构建数字孪生镜像主体，实现全球化运营与资产保护。',
        learnMore: '了解更多',
        stat1Value: '2K+',
        stat1Label: '服务案例',
        stat2Value: '3K+',
        stat2Label: '合规主体',
        stat3Value: '10+',
        stat3Label: '垂直领域',
      },
      servicesSection: {
        badge: '核心服务',
        title: '跨境数字主权解决方案',
        learnDetail: '了解详情',
      },
      whySection: {
        title: '为什么选择双清？',
        item1Title: 'DMCC官方ISP',
        item1Desc: '迪拜多种商品交易中心官方认证国际服务商，享有远程合规设立特权',
        item2Title: '百年家学传承',
        item2Desc: '深植1897年双清楼历史底蕴，传承革命精神与高洁情操',
        item3Title: '全链条服务',
        item3Desc: '从主体设立到业务落地，提供端到端的战略咨询与执行服务',
      },
      teamSection: {
        title: '专业团队',
      },
      teamMembers: {
        founderCeo: { displayName: '廖怀南', position: '创始人 & CEO' },
        partnerCfo: { displayName: '钟茜', position: '合伙人 & CFO' },
        partnerClo: { displayName: '付慧中', position: '合伙人 & CLO' },
      },
      partners: {
        item1: '迪拜商业中心',
        item2: 'UAE政府认证',
      },
    },
    // 页脚
    footer: {
      description: '深植于1897年"双清楼"历史底蕴，专注中阿跨境数字主权与家族基业传承服务。',
      slogan: '人月双清 传世基业',
      quickLinks: '快速链接',
      coreServices: '核心服务',
      contact: '联系方式',
      dubai: '迪拜办公室',
      china: '中国办公室',
      email: '邮箱',
      copyright: '© 2026 SHONCHIN MANOR & CO. 保留所有权利',
      privacy: '隐私政策',
      terms: '服务条款',
      compliance: '合规声明',
    },
    // 服务
    // 关于我们页面
    about: {
      badge: '关于我们',
      hero: {
        title: '人月双清 传世基业',
        subtitle: '承袭百年家学，为中国企业构建跨境数字主权',
      },
      values: {
        history: {
          title: '历史传承',
          description: '承袭1897年双清楼的百年家学，将廖仲恺、何香凝先生的革命精神与高洁情操融入现代商业服务。',
        },
        integrity: {
          title: '专业诚信',
          description: '秉持梅之清的职业操守，为客户提供合规、透明、可信赖的跨境商业咨询服务。',
        },
        innovation: {
          title: '创新服务',
          description: '运用数字孪生、远程合规等创新技术，为中国企业构建全球化运营的新范式。',
        },
        collaboration: {
          title: '跨境协同',
          description: '深耕中阿商业生态，打通自由区与本土市场壁垒，实现真正的跨境协同运营。',
        },
      },
      story: {
        badge: '品牌故事',
        title: '双清楼的',
        titleHighlight: '百年传承',
        year: '双清楼建立',
        paragraph1: '1897年，廖仲恺、何香凝先生在广州建立"双清楼"，取"月之清"与"梅之清"之意，寓意宏观洞察力与高洁操守的双重纯净。这座承载革命精神的建筑，见证了中国近代史的风云变幻。',
        paragraph2: 'SHONCHIN MANOR & CO. 的品牌名称源自"双清"的粤语发音（Shon Chin），Manor则象征家族基业的传承与守护。我们将先辈的革命精神转化为现代商业服务的核心价值，为中国企业在全球化浪潮中构建数字主权。',
        paragraph3: '从1897年的双清楼到2026年的迪拜DMCC，跨越百年的家学传承，始终秉持"人月双清"的理念——以月之清的宏观视野洞察全球商业格局，以梅之清的职业操守守护客户的传世基业。',
      },
      philosophy: {
        title: '双重纯净的',
        titleHighlight: '企业理念',
        subtitle: '月之清的宏观洞察力 × 梅之清的职业操守',
        moon: {
          title: '月之清',
          description: '如明月高悬，俯瞰全局。我们以宏观视野洞察全球商业格局，为客户提供前瞻性的战略规划与跨境布局方案。',
          point1: '深度研究中阿商业生态与政策法规',
          point2: '前瞻性把握游戏、AI、Web3等垂直领域趋势',
          point3: '构建全球化视野下的跨境运营战略',
        },
        plum: {
          title: '梅之清',
          description: '如寒梅傲雪，坚守操守。我们以高洁的职业道德为客户提供合规、透明、可信赖的专业服务。',
          point1: '严格遵守国际反洗钱与合规标准',
          point2: '透明化服务流程，保护客户隐私',
          point3: '长期主义价值观，守护客户传世基业',
        },
      },
      team: {
        badge: '核心团队',
        title: '专业团队',
        subtitle: '汇聚中阿跨境商业精英，为您提供专业服务',
      },
      founderQuote: {
        badge: '创始人寄语',
        paragraph1: '作为 SHONCHIN MANOR 的创始人，我深知在当今复杂的全球经济格局中，跨区域的协作远不止于资本的流动，更在于文化与战略的深度交融。凭借我在媒体娱乐与前沿科技领域的深厚积淀，我致力于将 SHONCHIN MANOR 打造成为一家卓越的战略咨询与资源整合平台。',
        paragraph2: '我们的使命非常明确：扎根阿联酋，面向亚洲，通过精准的行业洞察与资源配置，助力双边企业跨越文化与市场的壁垒。我坚信，通过融合家族传承的价值观与现代商业的创新动力，我们能够开启亚洲与中东合作共赢的新篇章，为全球精英合作伙伴创造真正的长效价值。',
      },
    },
    // 核心服务页面
    servicesPage: {
      badge: '核心服务',
      hero: {
        title: '跨境数字主权',
        titleLine2: '全链条解决方案',
        subtitle: '基于1897年双清楼百年家学传承，为中国企业提供阿联酋数字孪生镜像主体设立、垂直领域战略穿透与跨域合规运营的一站式服务',
      },
      benefitsTitle: '核心优势',
      whyChoose: {
        title: '为什么选择双清？',
        reason1: {
          title: 'DMCC官方ISP资质',
          description: '作为迪拜多种商品交易中心官方认证的国际服务商，享有远程合规设立特权，为客户提供最高效的服务通道',
        },
        reason2: {
          title: '百年家学传承',
          description: '深植于1897年双清楼历史底蕴，传承廖仲恺、何香凝先生的革命精神与高洁情操，以月之清的宏观洞察力与梅之清的职业操守服务客户',
        },
        reason3: {
          title: '垂直领域专精',
          description: '聚焦游戏电竞、RWA代币化、人工智能算力三大垂直领域，提供从主体设立到业务落地的全链条战略咨询与执行服务',
        },
        reason4: {
          title: '全程远程合规',
          description: '创新的数字孪生服务模式，让客户无需亲临迪拜即可完成主体设立与运营管理，大幅降低时间成本与差旅支出',
        },
      },
      cta: {
        title: '开启您的跨境之旅',
        description: '无论您是寻求海外市场拓展的企业，还是需要资产保护的家族，双清团队都将为您提供最专业的跨境商业咨询服务',
        button: '立即咨询',
      },
    },
    services: {
      digitalTwin: {
        title: '数字孪生与全球镜像运营',
        description: '作为迪拜DMCC官方国际服务商（ISP），为中国企业提供远程合规的数字孪生主体设立服务，实现免差旅、零物理存在的全球化运营。',
        features: '核心功能',
        benefits: '核心优势',
      },
      verticalStrategy: {
        title: '垂直领域战略穿透',
        description: '聚焦游戏电竞、RWA代币化、人工智能算力三大垂直领域，提供从主体设立到业务落地的全链条战略咨询与执行服务。',
        features: '核心功能',
        benefits: '核心优势',
      },
      crossDomain: {
        title: '跨域运营与合规管理',
        description: '基于Resolution No.11法规，协助企业打通自由区与本土市场壁垒，实现迪拜本土业务拓展与跨境合规运营。',
        features: '核心功能',
        benefits: '核心优势',
      },
    },
    contactPage: {
      hero: {
        title: '联系我们',
        subtitle: '开启您的跨境数字主权之旅',
      },
      form: {
        title: '留下您的信息',
        description: '请填写以下表单，我们的专业顾问将在24小时内与您取得联系，为您提供定制化的跨境商业咨询方案。',
        nameLabel: '姓名',
        namePlaceholder: '请输入您的姓名',
        companyLabel: '公司名称',
        companyPlaceholder: '请输入公司名称',
        emailLabel: '电子邮箱',
        emailPlaceholder: 'your@email.com',
        phoneLabel: '联系电话',
        phonePlaceholder: '+86 138 XXXX XXXX',
        serviceTypeLabel: '咨询服务类型',
        serviceTypePlaceholder: '请选择您感兴趣的服务',
        messageLabel: '留言内容',
        messagePlaceholder: '请详细描述您的需求或问题...',
        submitButton: '提交咨询',
        submitting: '提交中...',
        successTitle: '提交成功',
        successDescription: '我们已收到您的咨询，将在24小时内与您联系。',
        serviceOptions: {
          digitalTwin: '数字孪生与全球镜像运营',
          verticalStrategy: '垂直领域战略穿透',
          crossDomain: '跨域运营与合规管理',
          other: '其他咨询服务',
        },
        validation: {
          nameMin: '姓名至少需要2个字符',
          companyMin: '公司名称至少需要2个字符',
          emailInvalid: '请输入有效的邮箱地址',
          phoneMin: '请输入有效的电话号码',
          serviceTypeRequired: '请选择咨询服务类型',
          messageMin: '留言内容至少需要10个字符',
        },
      },
      info: {
        title: '联系方式',
        office: '迪拜办公室',
        phone: '联系电话',
        email: '电子邮箱',
        hours: '工作时间',
        hoursContent: '周一至周五: 9:00 - 18:00 (GST)\n周六至周日: 预约制',
        followUs: '关注我们',
        mapTitle: '办公地点',
        mapDescription: 'Mazaya Business Avenue BB2 - Jumeirah Lakes Towers (JLT), Dubai',
      },
      cta: {
        title: '准备好开启您的跨境之旅了吗？',
        description: '无论您是寻求数字孪生镜像、垂直领域战略咨询，还是跨域运营与合规管理，SHONCHIN MANOR & CO. 都将为您提供专业、可靠的一站式解决方案。',
        bookButton: '预约咨询',
        downloadButton: '下载服务手册',
      },
    },
  },
  'zh-TW': {
    nav: {
      home: '首頁',
      about: '關於我們',
      services: '核心服務',
      advisory: '顧問委員會',
      news: '公司動態',
      cases: '成功案例',
      contact: '聯繫我們',
    },
    home: {
      hero: {
        title: '人月雙清 傳世基業',
        subtitle: 'SHONCHIN MANOR & CO.',
        description: '為亞洲企業在阿聯酋構建數字孿生鏡像主體，實現全球化運營與資產保護。',
        cta: '立即諮詢',
        learnMore: '了解服務',
      },
      stats: {
        title: '核心優勢',
        subtitle: '深耕中阿跨境商業諮詢15年，服務超過200家中國企業',
        clients: '服務企業',
        assets: '資產管理',
        success: '成功率',
        countries: '國家覆蓋',
      },
      services: {
        title: '核心服務',
        subtitle: '四大核心業務板塊，為您提供全方位的跨境商業諮詢服務',
        viewAll: '查看全部服務',
      },
      trust: {
        title: '信任背書',
        subtitle: '獲得國際權威機構認證，值得信賴的跨境商業夥伴',
        dmcc: 'DMCC官方ISP',
        dmccDesc: '國際服務商資質',
        difc: 'DIFC認證',
        difcDesc: '金融中心認證',
        iso: 'ISO 9001',
        isoDesc: '質量管理體系',
        aml: 'AML合規',
        amlDesc: '反洗錢認證',
      },
      cta: {
        title: '開啟您的全球化之旅',
        description: '無論您是尋求海外市場拓展的企業，還是需要資產保護的家族，雙清團隊都將為您提供專業、可靠的跨境商業諮詢服務。',
        button: '預約諮詢',
      },
      about: {
        title: '深植百年家學',
        titleHighlight: '構建數字主權',
        description: '承襲1897年雙清樓歷史底蘊，為亞洲企業在阿聯酋構建數字孿生鏡像主體，實現全球化運營與資產保護。',
        learnMore: '了解更多',
        stat1Value: '2K+',
        stat1Label: '服務案例',
        stat2Value: '3K+',
        stat2Label: '合規主體',
        stat3Value: '10+',
        stat3Label: '垂直領域',
      },
      servicesSection: {
        badge: '核心服務',
        title: '跨境數字主權解決方案',
        learnDetail: '了解詳情',
      },
      whySection: {
        title: '為什麼選擇雙清？',
        item1Title: 'DMCC官方ISP',
        item1Desc: '杜拜多種商品交易中心官方認證國際服務商，享有遠程合規設立特權',
        item2Title: '百年家學傳承',
        item2Desc: '深植1897年雙清樓歷史底蘊，傳承革命精神與高潔情操',
        item3Title: '全鏈條服務',
        item3Desc: '從主體設立到業務落地，提供端到端的戰略諮詢與執行服務',
      },
      teamSection: {
        title: '專業團隊',
      },
      teamMembers: {
        founderCeo: { displayName: '廖懷南', position: '創辦人 & CEO' },
        partnerCfo: { displayName: '鍾茜', position: '合夥人 & CFO' },
        partnerClo: { displayName: '付慧中', position: '合夥人 & CLO' },
      },
      partners: {
        item1: '杜拜商業中心',
        item2: 'UAE政府認證',
      },
    },
    footer: {
      description: '深植於1897年「雙清樓」歷史底蘊，專注中阿跨境數字主權與家族基業傳承服務。',
      slogan: '人月雙清 傳世基業',
      quickLinks: '快速連結',
      coreServices: '核心服務',
      contact: '聯繫方式',
      dubai: '杜拜辦公室',
      china: '中國辦公室',
      email: '郵箱',
      copyright: '© 2026 SHONCHIN MANOR & CO. 保留所有權利',
      privacy: '隱私政策',
      terms: '服務條款',
      compliance: '合規聲明',
    },
    // 关于我们页面（繁体中文）
    about: {
      badge: '關於我們',
      hero: {
        title: '人月雙清 傳世基業',
        subtitle: '承襲百年家學，為中國企業構建跨境數字主權',
      },
      values: {
        history: {
          title: '歷史傳承',
          description: '承襲1897年雙清樓的百年家學，將廖仲愷、何香凝先生的革命精神與高潔情操融入現代商業服務。',
        },
        integrity: {
          title: '專業誠信',
          description: '秉持梅之清的職業操守，為客戶提供合規、透明、可信賴的跨境商業諮詢服務。',
        },
        innovation: {
          title: '創新服務',
          description: '運用數字孿生、遠程合規等創新技術，為中國企業構建全球化運營的新範式。',
        },
        collaboration: {
          title: '跨境協同',
          description: '深耕中阿商業生態，打通自由區與本土市場壁壘，實現真正的跨境協同運營。',
        },
      },
      story: {
        badge: '品牌故事',
        title: '雙清樓的',
        titleHighlight: '百年傳承',
        year: '雙清樓建立',
        paragraph1: '1897年，廖仲愷、何香凝先生在廣州建立「雙清樓」，取「月之清」與「梅之清」之意，寓意宏觀洞察力與高潔操守的雙重純淨。這座承載革命精神的建築，見證了中國近代史的風雲變幻。',
        paragraph2: 'SHONCHIN MANOR & CO. 的品牌名稱源自「雙清」的粵語發音（Shon Chin），Manor則象徵家族基業的傳承與守護。我們將先輩的革命精神轉化為現代商業服務的核心價值，為中國企業在全球化浪潮中構建數字主權。',
        paragraph3: '從1897年的雙清樓到2026年的杜拜DMCC，跨越百年的家學傳承，始終秉持「人月雙清」的理念——以月之清的宏觀視野洞察全球商業格局，以梅之清的職業操守守護客戶的傳世基業。',
      },
      philosophy: {
        title: '雙重純淨的',
        titleHighlight: '企業理念',
        subtitle: '月之清的宏觀洞察力 × 梅之清的職業操守',
        moon: {
          title: '月之清',
          description: '如明月高懸，俯瞰全局。我們以宏觀視野洞察全球商業格局，為客戶提供前瞻性的戰略規劃與跨境佈局方案。',
          point1: '深度研究中阿商業生態與政策法規',
          point2: '前瞻性把握遊戲、AI、Web3等垂直領域趨勢',
          point3: '構建全球化視野下的跨境運營戰略',
        },
        plum: {
          title: '梅之清',
          description: '如寒梅傲雪，堅守操守。我們以高潔的職業道德為客戶提供合規、透明、可信賴的專業服務。',
          point1: '嚴格遵守國際反洗錢與合規標準',
          point2: '透明化服務流程，保護客戶隱私',
          point3: '長期主義價值觀，守護客戶傳世基業',
        },
      },
      team: {
        badge: '核心團隊',
        title: '專業團隊',
        subtitle: '匯聚中阿跨境商業精英，為您提供專業服務',
      },
      founderQuote: {
        badge: '創辦人寄語',
        paragraph1: '作為 SHONCHIN MANOR 的創辦人，我深知在當今複雜的全球經濟格局中，跨區域的協作遠不止於資本的流動，更在於文化與戰略的深度交融。憑藉我在媒體娛樂與前沿科技領域的深厚積澱，我致力於將 SHONCHIN MANOR 打造成為一家卓越的戰略諮詢與資源整合平台。',
        paragraph2: '我們的使命非常明確：紮根阿聯酋，面向亞洲，通過精準的行業洞察與資源配置，助力雙邊企業跨越文化與市場的壁壘。我堅信，通過融合家族傳承的價值觀與現代商業的創新動力，我們能夠開啟亞洲與中東合作共贏的新篇章，為全球精英合作夥伴創造真正的長效價值。',
      },
    },
    // 核心服务页面（繁体中文）
    servicesPage: {
      badge: '核心服務',
      hero: {
        title: '跨境數字主權',
        titleLine2: '全鏈條解決方案',
        subtitle: '基於1897年雙清樓百年家學傳承，為中國企業提供阿聯酋數字孿生鏡像主體設立、垂直領域戰略穿透與跨域合規運營的一站式服務',
      },
      benefitsTitle: '核心優勢',
      whyChoose: {
        title: '為什麼選擇雙清？',
        reason1: {
          title: 'DMCC官方ISP資質',
          description: '作為杜拜多種商品交易中心官方認證的國際服務商，享有遠程合規設立特權，為客戶提供最高效的服務通道',
        },
        reason2: {
          title: '百年家學傳承',
          description: '深植於1897年雙清樓歷史底蘊，傳承廖仲愷、何香凝先生的革命精神與高潔情操，以月之清的宏觀洞察力與梅之清的職業操守服務客戶',
        },
        reason3: {
          title: '垂直領域專精',
          description: '聚焦遊戲電競、RWA代幣化、人工智能算力三大垂直領域，提供從主體設立到業務落地的全鏈條戰略諮詢與執行服務',
        },
        reason4: {
          title: '全程遠程合規',
          description: '創新的數字孿生服務模式，讓客戶無需親臨杜拜即可完成主體設立與運營管理，大幅降低時間成本與差旅支出',
        },
      },
      cta: {
        title: '開啟您的跨境之旅',
        description: '無論您是尋求海外市場拓展的企業，還是需要資產保護的家族，雙清團隊都將為您提供最專業的跨境商業諮詢服務',
        button: '立即諮詢',
      },
    },
    services: {
      digitalTwin: {
        title: '數字孿生與全球鏡像運營',
        description: '作為杜拜DMCC官方國際服務商（ISP），為中國企業提供遠程合規的數字孿生主體設立服務，實現免差旅、零物理存在的全球化運營。',
        features: '核心功能',
        benefits: '核心優勢',
      },
      verticalStrategy: {
        title: '垂直領域戰略穿透',
        description: '聚焦遊戲電競、RWA代幣化、人工智能算力三大垂直領域，提供從主體設立到業務落地的全鏈條戰略諮詢與執行服務。',
        features: '核心功能',
        benefits: '核心優勢',
      },
      crossDomain: {
        title: '跨域運營與合規管理',
        description: '基於Resolution No.11法規，協助企業打通自由區與本土市場壁壘，實現杜拜本土業務拓展與跨境合規運營。',
        features: '核心功能',
        benefits: '核心優勢',
      },
    },
    contactPage: {
      hero: {
        title: '聯繫我們',
        subtitle: '開啟您的跨境數字主權之旅',
      },
      form: {
        title: '留下您的資訊',
        description: '請填寫以下表單，我們的專業顧問將在24小時內與您取得聯繫，為您提供定制化的跨境商業諮詢方案。',
        nameLabel: '姓名',
        namePlaceholder: '請輸入您的姓名',
        companyLabel: '公司名稱',
        companyPlaceholder: '請輸入公司名稱',
        emailLabel: '電子郵箱',
        emailPlaceholder: 'your@email.com',
        phoneLabel: '聯繫電話',
        phonePlaceholder: '+86 138 XXXX XXXX',
        serviceTypeLabel: '諮詢服務類型',
        serviceTypePlaceholder: '請選擇您感興趣的服務',
        messageLabel: '留言內容',
        messagePlaceholder: '請詳細描述您的需求或問題...',
        submitButton: '提交諮詢',
        submitting: '提交中...',
        successTitle: '提交成功',
        successDescription: '我們已收到您的諮詢，將在24小時內與您聯繫。',
        serviceOptions: {
          digitalTwin: '數字孿生與全球鏡像運營',
          verticalStrategy: '垂直領域戰略穿透',
          crossDomain: '跨域運營與合規管理',
          other: '其他諮詢服務',
        },
        validation: {
          nameMin: '姓名至少需要2個字符',
          companyMin: '公司名稱至少需要2個字符',
          emailInvalid: '請輸入有效的郵箱地址',
          phoneMin: '請輸入有效的電話號碼',
          serviceTypeRequired: '請選擇諮詢服務類型',
          messageMin: '留言內容至少需要10個字符',
        },
      },
      info: {
        title: '聯繫方式',
        office: '杜拜辦公室',
        phone: '聯繫電話',
        email: '電子郵箱',
        hours: '工作時間',
        hoursContent: '週一至週五: 9:00 - 18:00 (GST)\n週六至週日: 預約制',
        followUs: '關注我們',
        mapTitle: '辦公地點',
        mapDescription: 'Mazaya Business Avenue BB2 - Jumeirah Lakes Towers (JLT), Dubai',
      },
      cta: {
        title: '準備好開啟您的跨境之旅了嗎？',
        description: '無論您是尋求數字孿生鏡像、垂直領域戰略諮詢，還是跨域運營與合規管理，SHONCHIN MANOR & CO. 都將為您提供專業、可靠的一站式解決方案。',
        bookButton: '預約諮詢',
        downloadButton: '下載服務手冊',
      },
    },
  },
  'en': {
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      advisory: 'Advisory Board',
      news: 'Company News',
      cases: 'Case Studies',
      contact: 'Contact',
    },
    home: {
      hero: {
        title: 'Double Clarity\nEnduring Legacy',
        subtitle: 'SHONCHIN MANOR & CO.',
        description: 'Building digital twin mirror entities for Asian enterprises in the UAE to achieve global operations and asset protection.',
        cta: 'Get Started',
        learnMore: 'Learn More',
      },
      stats: {
        title: 'Core Advantages',
        subtitle: '15 years of expertise in China-Arab cross-border business consulting, serving over 200 Chinese enterprises',
        clients: 'Clients Served',
        assets: 'Assets Under Management',
        success: 'Success Rate',
        countries: 'Countries Covered',
      },
      services: {
        title: 'Core Services',
        subtitle: 'Four core business segments providing comprehensive cross-border business consulting services',
        viewAll: 'View All Services',
      },
      trust: {
        title: 'Trust & Credentials',
        subtitle: 'Certified by international authorities, your trusted cross-border business partner',
        dmcc: 'DMCC Official ISP',
        dmccDesc: 'International Service Provider',
        difc: 'DIFC Certified',
        difcDesc: 'Financial Center Certification',
        iso: 'ISO 9001',
        isoDesc: 'Quality Management System',
        aml: 'AML Compliance',
        amlDesc: 'Anti-Money Laundering',
      },
      cta: {
        title: 'Start Your Global Journey',
        description: 'Whether you are an enterprise seeking overseas market expansion or a family in need of asset protection, the SHONCHIN MANOR team will provide you with professional and reliable cross-border business consulting services.',
        button: 'Schedule Consultation',
      },
      about: {
        title: 'Century-old Wisdom,',
        titleHighlight: 'Building Digital Sovereignty',
        description: 'Rooted in the 1897 Shuangqing heritage, we build digital twin entities in the UAE for Asian enterprises, enabling global operations and asset protection.',
        learnMore: 'Learn More',
        stat1Value: '2K+',
        stat1Label: 'Cases Served',
        stat2Value: '3K+',
        stat2Label: 'Compliant Entities',
        stat3Value: '10+',
        stat3Label: 'Vertical Domains',
      },
      servicesSection: {
        badge: 'Core Services',
        title: 'Cross-Border Digital Sovereignty Solutions',
        learnDetail: 'Learn More',
      },
      whySection: {
        title: 'Why Choose Shonchin?',
        item1Title: 'DMCC Official ISP',
        item1Desc: 'Officially certified International Service Provider by Dubai Multi Commodities Centre, with remote compliance setup privileges',
        item2Title: 'Century-old Heritage',
        item2Desc: 'Rooted in the 1897 Shuangqing Manor heritage, inheriting its revolutionary spirit and noble integrity',
        item3Title: 'End-to-End Service',
        item3Desc: 'From entity setup to business implementation, providing complete strategic consulting and execution services',
      },
      teamSection: {
        title: 'Our Expert Team',
      },
      teamMembers: {
        founderCeo: { displayName: 'Aaron Liao', position: 'Founder & CEO' },
        partnerCfo: { displayName: 'Grace Zhong', position: 'Partner & CFO' },
        partnerClo: { displayName: 'Selena Fu', position: 'Partner & CLO' },
      },
      partners: {
        item1: 'Dubai Business Centre',
        item2: 'UAE Government Certified',
      },
    },
    footer: {
      description: 'Rooted in the 1897 Shuangqing Heritage, specializing in China-Arab cross-border digital sovereignty and family legacy services.',
      slogan: 'Double Clarity, Enduring Legacy',
      quickLinks: 'Quick Links',
      coreServices: 'Core Services',
      contact: 'Contact',
      dubai: 'Dubai Office',
      china: 'China Office',
      email: 'Email',
      copyright: '© 2026 SHONCHIN MANOR & CO. All Rights Reserved',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      compliance: 'Compliance',
    },
    // About page
    about: {
      badge: 'About Us',
      hero: {
        title: 'Double Clarity, Enduring Legacy',
        subtitle: 'Inheriting century-old wisdom to build cross-border digital sovereignty for Chinese enterprises',
      },
      values: {
        history: {
          title: 'Historical Heritage',
          description: 'Inheriting the century-old wisdom of Shuangqing Manor since 1897, integrating the revolutionary spirit and noble integrity of Mr. Liao Zhongkai and Ms. He Xiangning into modern business services.',
        },
        integrity: {
          title: 'Professional Integrity',
          description: 'Upholding the professional ethics of "Plum Clarity", providing compliant, transparent, and trustworthy cross-border business consulting services to clients.',
        },
        innovation: {
          title: 'Innovative Services',
          description: 'Utilizing innovative technologies such as digital twins and remote compliance to build new paradigms for global operations for Chinese enterprises.',
        },
        collaboration: {
          title: 'Cross-border Collaboration',
          description: 'Deeply cultivating the China-Arab business ecosystem, breaking through barriers between free zones and local markets to achieve true cross-border collaborative operations.',
        },
      },
      story: {
        badge: 'Brand Story',
        title: 'The',
        titleHighlight: 'Century-old Heritage of Shuangqing Manor',
        year: 'Shuangqing Manor Established',
        paragraph1: 'In 1897, Mr. Liao Zhongkai and Ms. He Xiangning established "Shuangqing Manor" in Guangzhou, named after "Moon Clarity" and "Plum Clarity", symbolizing the dual purity of macro insight and noble integrity. This building, carrying the revolutionary spirit, witnessed the turbulent changes in modern Chinese history.',
        paragraph2: 'The brand name SHONCHIN MANOR & CO. originates from the Cantonese pronunciation of "Shuangqing" (Shon Chin), while Manor symbolizes the inheritance and protection of family legacy. We transform the revolutionary spirit of our ancestors into the core values of modern business services, building digital sovereignty for Chinese enterprises in the wave of globalization.',
        paragraph3: 'From Shuangqing Manor in 1897 to Dubai DMCC in 2026, spanning a century of family wisdom inheritance, we always uphold the concept of "Double Clarity" - using the macro vision of Moon Clarity to insight into the global business landscape, and using the professional ethics of Plum Clarity to protect clients\' enduring legacy.',
      },
      philosophy: {
        title: 'The Dual Purity of',
        titleHighlight: 'Corporate Philosophy',
        subtitle: 'Moon Clarity\'s Macro Insight × Plum Clarity\'s Professional Ethics',
        moon: {
          title: 'Moon Clarity',
          description: 'Like the bright moon hanging high, overlooking the overall situation. We provide clients with forward-looking strategic planning and cross-border layout solutions with a macro perspective to insight into the global business landscape.',
          point1: 'In-depth research on China-Arab business ecosystem and policy regulations',
          point2: 'Forward-looking grasp of trends in vertical fields such as gaming, AI, and Web3',
          point3: 'Building cross-border operation strategies from a global perspective',
        },
        plum: {
          title: 'Plum Clarity',
          description: 'Like the plum blossom standing proud in snow, adhering to integrity. We provide clients with compliant, transparent, and trustworthy professional services with noble professional ethics.',
          point1: 'Strictly comply with international anti-money laundering and compliance standards',
          point2: 'Transparent service processes to protect client privacy',
          point3: 'Long-term value orientation to protect clients\' enduring legacy',
        },
      },
      team: {
        badge: 'Core Team',
        title: 'Professional Team',
        subtitle: 'Gathering cross-border business elites to provide you with professional services',
      },
      founderQuote: {
        badge: "Founder's Message",
        paragraph1: 'As the founder of SHONCHIN MANOR, I understand that in today\'s complex global economic landscape, cross-regional collaboration goes far beyond the flow of capital — it is fundamentally about the deep integration of culture and strategy. Drawing on my extensive background in media entertainment and frontier technology, I am committed to building SHONCHIN MANOR into a world-class platform for strategic advisory and resource integration.',
        paragraph2: 'Our mission is clear: rooted in the UAE, facing Asia, we leverage precise industry insights and resource allocation to help bilateral enterprises transcend cultural and market barriers. I firmly believe that by merging time-honored family values with the innovative momentum of modern business, we can open a new chapter of Asia-Middle East partnership and create lasting value for elite partners around the world.',
      },
    },
    // Services page
    servicesPage: {
      badge: 'Core Services',
      hero: {
        title: 'Cross-border Digital Sovereignty',
        titleLine2: 'End-to-End Solutions',
        subtitle: 'Based on the century-old heritage of Shuangqing Manor since 1897, we provide Chinese enterprises with one-stop services including UAE digital twin entity setup, vertical domain strategic penetration, and cross-domain compliance operations',
      },
      benefitsTitle: 'Core Benefits',
      whyChoose: {
        title: 'Why Choose Shonchin?',
        reason1: {
          title: 'DMCC Official ISP Qualification',
          description: 'As an officially certified International Service Provider by Dubai Multi Commodities Centre, we enjoy remote compliance setup privileges, providing clients with the most efficient service channels',
        },
        reason2: {
          title: 'Century-old Heritage',
          description: 'Rooted in the historical heritage of Shuangqing Manor since 1897, inheriting the revolutionary spirit and noble integrity of Mr. Liao Zhongkai and Ms. He Xiangning, serving clients with Moon Clarity\'s macro insight and Plum Clarity\'s professional ethics',
        },
        reason3: {
          title: 'Vertical Domain Expertise',
          description: 'Focusing on three vertical domains: gaming esports, RWA tokenization, and AI computing power, providing end-to-end strategic consulting and execution services from entity setup to business implementation',
        },
        reason4: {
          title: 'Full Remote Compliance',
          description: 'Innovative digital twin service model allows clients to complete entity setup and operational management without visiting Dubai, significantly reducing time costs and travel expenses',
        },
      },
      cta: {
        title: 'Start Your Cross-Border Journey',
        description: 'Whether you are an enterprise seeking overseas market expansion or a family in need of asset protection, the SHONCHIN MANOR team will provide you with the most professional cross-border business consulting services',
        button: 'Contact Us Now',
      },
    },
    services: {
      digitalTwin: {
        title: 'Digital Twin & Global Mirror Operations',
        description: 'As an official DMCC International Service Provider (ISP) in Dubai, we provide remote compliance digital twin entity setup services for Chinese enterprises, enabling global operations without travel or physical presence.',
        features: 'Key Features',
        benefits: 'Core Benefits',
      },
      verticalStrategy: {
        title: 'Vertical Domain Strategic Penetration',
        description: 'Focusing on three vertical domains: gaming esports, RWA tokenization, and AI computing power, we provide end-to-end strategic consulting and execution services from entity setup to business implementation.',
        features: 'Key Features',
        benefits: 'Core Benefits',
      },
      crossDomain: {
        title: 'Cross-Domain Operations & Compliance Management',
        description: 'Based on Resolution No.11 regulations, we assist enterprises in bridging free zone and mainland market barriers, enabling Dubai mainland business expansion and cross-border compliance operations.',
        features: 'Key Features',
        benefits: 'Core Benefits',
      },
    },
    contactPage: {
      hero: {
        title: 'Contact Us',
        subtitle: 'Start Your Cross-Border Digital Sovereignty Journey',
      },
      form: {
        title: 'Leave Your Information',
        description: 'Please fill out the form below, and our professional consultants will contact you within 24 hours to provide customized cross-border business consulting solutions.',
        nameLabel: 'Name',
        namePlaceholder: 'Please enter your name',
        companyLabel: 'Company Name',
        companyPlaceholder: 'Please enter company name',
        emailLabel: 'Email',
        emailPlaceholder: 'your@email.com',
        phoneLabel: 'Phone',
        phonePlaceholder: '+971 4 XXX XXXX',
        serviceTypeLabel: 'Service Type',
        serviceTypePlaceholder: 'Please select the service you are interested in',
        messageLabel: 'Message',
        messagePlaceholder: 'Please describe your needs or questions in detail...',
        submitButton: 'Submit Inquiry',
        submitting: 'Submitting...',
        successTitle: 'Submission Successful',
        successDescription: 'We have received your inquiry and will contact you within 24 hours.',
        serviceOptions: {
          digitalTwin: 'Digital Twin & Global Mirror Operations',
          verticalStrategy: 'Vertical Domain Strategic Penetration',
          crossDomain: 'Cross-Domain Operations & Compliance Management',
          other: 'Other Consulting Services',
        },
        validation: {
          nameMin: 'Name must be at least 2 characters',
          companyMin: 'Company name must be at least 2 characters',
          emailInvalid: 'Please enter a valid email address',
          phoneMin: 'Please enter a valid phone number',
          serviceTypeRequired: 'Please select a service type',
          messageMin: 'Message must be at least 10 characters',
        },
      },
      info: {
        title: 'Contact Information',
        office: 'Dubai Office',
        phone: 'Phone',
        email: 'Email',
        hours: 'Business Hours',
        hoursContent: 'Monday - Friday: 9:00 - 18:00 (GST)\nSaturday - Sunday: By Appointment',
        followUs: 'Follow Us',
        mapTitle: 'Office Location',
        mapDescription: 'Mazaya Business Avenue BB2 - Jumeirah Lakes Towers (JLT), Dubai',
      },
      cta: {
        title: 'Ready to Start Your Cross-Border Journey?',
        description: 'Whether you are seeking digital twin solutions, vertical domain strategic consulting, or cross-domain operations and compliance management, SHONCHIN MANOR & CO. will provide you with professional and reliable one-stop solutions.',
        bookButton: 'Book Consultation',
        downloadButton: 'Download Service Brochure',
      },
    },
  },
  'ja': {
    nav: {
      home: 'ホーム',
      about: '会社概要',
      services: 'サービス',
      advisory: '諮問委員会',
      news: '会社ニュース',
      cases: '事例紹介',
      contact: 'お問い合わせ',
    },
    home: {
      hero: {
        title: '人月双清 伝世基業',
        subtitle: 'SHONCHIN MANOR & CO.',
        description: 'アジア企業のためにUAEでデジタルツイン鏡像エンティティを構築し、グローバル運営と資産保護を実現します。',
        cta: 'お問い合わせ',
        learnMore: '詳細を見る',
      },
      stats: {
        title: 'コア・アドバンテージ',
        subtitle: '中国・アラブ間のクロスボーダービジネスコンサルティングで15年の実績、200社以上の中国企業にサービスを提供',
        clients: 'サービス提供企業',
        assets: '資産管理規模',
        success: '成功率',
        countries: '対応国数',
      },
      services: {
        title: 'コアサービス',
        subtitle: '4つのコアビジネスセグメントで包括的なクロスボーダービジネスコンサルティングサービスを提供',
        viewAll: 'すべてのサービスを見る',
      },
      trust: {
        title: '信頼の証',
        subtitle: '国際的な権威機関の認証を取得、信頼できるクロスボーダービジネスパートナー',
        dmcc: 'DMCC公式ISP',
        dmccDesc: '国際サービスプロバイダー資格',
        difc: 'DIFC認証',
        difcDesc: '金融センター認証',
        iso: 'ISO 9001',
        isoDesc: '品質管理システム',
        aml: 'AMLコンプライアンス',
        amlDesc: 'マネーロンダリング対策認証',
      },
      cta: {
        title: 'グローバル展開を始めましょう',
        description: '海外市場への進出を目指す企業様、資産保護が必要なご家族様、双清チームが専門的で信頼できるクロスボーダービジネスコンサルティングサービスを提供いたします。',
        button: '相談予約',
      },
      about: {
        title: '百年の知恵、',
        titleHighlight: 'デジタル主権の構築',
        description: '1897年の双清楼の遺産に根ざし、UAE においてアジア企業のデジタルツインエンティティを構築し、グローバル運営と資産保護を実現します。',
        learnMore: '詳細を見る',
        stat1Value: '2K+',
        stat1Label: 'サービス事例',
        stat2Value: '3K+',
        stat2Label: '合規エンティティ',
        stat3Value: '10+',
        stat3Label: '垂直領域',
      },
      servicesSection: {
        badge: 'コアサービス',
        title: '国境を越えたデジタル主権ソリューション',
        learnDetail: '詳細を見る',
      },
      whySection: {
        title: 'なぜ双清を選ぶのか？',
        item1Title: 'DMCC公式ISP',
        item1Desc: 'ドバイ多目的商品センター公式認定国際サービスプロバイダー、リモートコンプライアンス設立特権',
        item2Title: '百年の伝統',
        item2Desc: '1897年双清楼の歴史的遺産に根ざし、革命精神と高潔な品格を継承',
        item3Title: 'フルチェーンサービス',
        item3Desc: 'エンティティ設立からビジネス実装まで、エンドツーエンドの戦略コンサルティングと実行サービス',
      },
      teamSection: {
        title: '専門チーム',
      },
      teamMembers: {
        founderCeo: { displayName: '廖怀南 (Aaron Liao)', position: '創業者 & CEO' },
        partnerCfo: { displayName: '钟茜 (Grace Zhong)', position: 'パートナー & CFO' },
        partnerClo: { displayName: '付慧中 (Selena Fu)', position: 'パートナー & CLO' },
      },
      partners: {
        item1: 'ドバイビジネスセンター',
        item2: 'UAE政府認定',
      },
    },
    footer: {
      description: '1897年「双清楼」の歴史的遺産に根ざし、中国・アラブ間のクロスボーダーデジタル主権と家族事業承継サービスに特化。',
      slogan: '人月双清 伝世基業',
      quickLinks: 'クイックリンク',
      coreServices: 'コアサービス',
      contact: 'お問い合わせ',
      dubai: 'ドバイオフィス',
      china: '中国オフィス',
      email: 'メール',
      copyright: '© 2026 SHONCHIN MANOR & CO. All Rights Reserved',
      privacy: 'プライバシーポリシー',
      terms: '利用規約',
      compliance: 'コンプライアンス',
    },
    // 会社概要ページ（日本語）
    about: {
      badge: '会社概要',
      hero: {
        title: '人月双清 伝世基業',
        subtitle: '百年の知恵を継承し、中国企業のクロスボーダーデジタル主権を構築',
      },
      values: {
        history: {
          title: '歴史の継承',
          description: '1897年の双清楼の百年の知恵を継承し、廖仲愷・何香凝先生の革命精神と高潔な品格を現代のビジネスサービスに融合させています。',
        },
        integrity: {
          title: '誠実なプロ意識',
          description: '「梅の清」の職業倫理を堅持し、コンプライアンス、透明性、信頼性の高いクロスボーダービジネスコンサルティングサービスを提供します。',
        },
        innovation: {
          title: '革新的サービス',
          description: 'デジタルツインやリモートコンプライアンスなどの革新技術を活用し、中国企業のグローバル運営の新たなパラダイムを構築します。',
        },
        collaboration: {
          title: 'クロスボーダー協力',
          description: '中国・アラブビジネスエコシステムを深く耕し、フリーゾーンと本土市場の障壁を取り除き、真のクロスボーダー協力運営を実現します。',
        },
      },
      story: {
        badge: 'ブランドストーリー',
        title: '双清楼の',
        titleHighlight: '百年の遺産',
        year: '双清楼設立',
        paragraph1: '1897年、廖仲愷・何香凝先生が広州に「双清楼」を設立しました。「月の清」と「梅の清」から名付けられ、マクロな洞察力と高潔な品格の双重の純粋さを象徴しています。',
        paragraph2: 'SHONCHIN MANOR & CO. のブランド名は「双清」の広東語の発音（Shon Chin）に由来し、Manorは家族の遺産の継承と保護を象徴します。先人の革命精神を現代のビジネスサービスのコア価値に転換し、グローバル化の波の中で中国企業のデジタル主権を構築します。',
        paragraph3: '1897年の双清楼から2026年のドバイDMCCまで、百年の知恵の継承を跨ぎ、常に「人月双清」の理念を堅持しています——月の清のマクロビジョンでグローバルなビジネス環境を洞察し、梅の清の職業倫理でお客様の永続的な事業を守護します。',
      },
      philosophy: {
        title: '双重の純粋さの',
        titleHighlight: '企業理念',
        subtitle: '月の清のマクロ洞察力 × 梅の清の職業倫理',
        moon: {
          title: '月の清',
          description: '高く輝く月のように、全体を俯瞰します。マクロな視点でグローバルなビジネス環境を洞察し、前瞻的な戦略計画とクロスボーダーレイアウトソリューションをお客様に提供します。',
          point1: '中国・アラブビジネスエコシステムと政策規制の詳細な研究',
          point2: 'ゲーム、AI、Web3などの垂直領域のトレンドを前瞻的に把握',
          point3: 'グローバルな視点からのクロスボーダー運営戦略の構築',
        },
        plum: {
          title: '梅の清',
          description: '厳寒の中で誇り高く咲く梅のように、誠実さを守ります。高潔な職業倫理でコンプライアンス、透明性、信頼性の高い専門サービスを提供します。',
          point1: '国際的なマネーロンダリング防止とコンプライアンス基準の厳守',
          point2: '透明なサービスプロセスでお客様のプライバシーを保護',
          point3: '長期的な価値観でお客様の永続的な事業を守護',
        },
      },
      team: {
        badge: 'コアチーム',
        title: '専門チーム',
        subtitle: '中国・アラブクロスボーダービジネスの精鋭を集め、専門サービスを提供します',
      },
      founderQuote: {
        badge: '創業者メッセージ',
        paragraph1: 'SHONCHIN MANORの創業者として、今日の複雑なグローバル経済の中で、地域を越えた協力は資本の流れにとどまらず、文化と戦略の深い融合こそが本質であると深く理解しています。メディアエンターテインメントと先端テクノロジー分野での豊富な経験を活かし、SHONCHIN MANORを卓越した戦略コンサルティングとリソース統合のプラットフォームとして構築することに尽力しています。',
        paragraph2: '私たちの使命は明確です。UAEに根ざし、アジアを向き、精確な業界洞察とリソース配置によって、双方の企業が文化と市場の壁を越えられるよう支援します。家族から受け継いだ価値観と現代ビジネスの革新的な推進力を融合させることで、アジアと中東の協力・共栄の新章を開き、世界のエリートパートナーに真の長期的価値を創造できると確信しています。',
      },
    },
    // 核心服务页面（日语）
    servicesPage: {
      badge: 'コアサービス',
      hero: {
        title: '国境を越えたデジタル主権',
        titleLine2: 'エンドツーエンドソリューション',
        subtitle: '1897年創業の双清楼の百年の伝統に基づき、中国企業向けにUAEデジタルツインエンティティ設立、垂直領域戦略浸透、クロスドメインコンプライアンス運営のワンストップサービスを提供します',
      },
      benefitsTitle: 'コアベネフィット',
      whyChoose: {
        title: 'なぜ双清を選ぶのか？',
        reason1: {
          title: 'DMCC公式ISP資格',
          description: 'ドバイ多目的商品センター公式認定の国際サービスプロバイダーとして、リモートコンプライアンス設立特権を享受し、お客様に最も効率的なサービスチャネルを提供します',
        },
        reason2: {
          title: '百年の伝統継承',
          description: '1897年の双清楼の歴史的遺産に根ざし、廖仲愷・何香凝先生の革命精神と高潔な品格を継承し、月の清のマクロ洞察力と梅の清の職業倫理でお客様にサービスを提供します',
        },
        reason3: {
          title: '垂直領域の専門性',
          description: 'ゲームeスポーツ、RWAトークン化、AI計算能力の3つの垂直領域に焦点を当て、エンティティ設立からビジネス実装までのエンドツーエンド戦略コンサルティングと実行サービスを提供します',
        },
        reason4: {
          title: '完全リモートコンプライアンス',
          description: '革新的なデジタルツインサービスモデルにより、お客様はドバイを訪問することなくエンティティ設立と運営管理を完了でき、時間コストと出張費用を大幅に削減します',
        },
      },
      cta: {
        title: '国境を越えた旅を始めましょう',
        description: '海外市場拡大を目指す企業でも、資産保護が必要なファミリーでも、双清チームは最もプロフェッショナルな国境を越えたビジネスコンサルティングサービスを提供します',
        button: '今すぐお問い合わせ',
      },
    },
    services: {
      digitalTwin: {
        title: 'デジタルツイン＆グローバルミラー運営',
        description: 'ドバイDMCC公式国際サービスプロバイダー（ISP）として、中国企業向けにリモートコンプライアンスのデジタルツインエンティティ設立サービスを提供し、出張不要・物理的存在ゼロのグローバル運営を実現します。',
        features: '主な機能',
        benefits: 'コアベネフィット',
      },
      verticalStrategy: {
        title: '垂直領域戦略浸透',
        description: 'ゲームeスポーツ、RWAトークン化、AI計算能力の3つの垂直領域に焦点を当て、エンティティ設立からビジネス実装までのエンドツーエンドの戦略コンサルティングと実行サービスを提供します。',
        features: '主な機能',
        benefits: 'コアベネフィット',
      },
      crossDomain: {
        title: 'クロスドメイン運営＆コンプライアンス管理',
        description: 'Resolution No.11規制に基づき、企業がフリーゾーンと本土市場の障壁を橋渡しし、ドバイ本土ビジネス拡大と国境を越えたコンプライアンス運営を実現するのを支援します。',
        features: '主な機能',
        benefits: 'コアベネフィット',
      },
    },
    contactPage: {
      hero: {
        title: 'お問い合わせ',
        subtitle: '国境を越えたデジタル主権の旅を始めましょう',
      },
      form: {
        title: '情報をお残しください',
        description: '以下のフォームにご記入ください。専門コンサルタントが24時間以内にご連絡し、カスタマイズされた国境を越えたビジネスコンサルティングソリューションを提供いたします。',
        nameLabel: '氏名',
        namePlaceholder: 'お名前を入力してください',
        companyLabel: '会社名',
        companyPlaceholder: '会社名を入力してください',
        emailLabel: 'メールアドレス',
        emailPlaceholder: 'your@email.com',
        phoneLabel: '電話番号',
        phonePlaceholder: '+971 4 XXX XXXX',
        serviceTypeLabel: 'サービスタイプ',
        serviceTypePlaceholder: '興味のあるサービスを選択してください',
        messageLabel: 'メッセージ',
        messagePlaceholder: 'ご要望や質問を詳しくご記入ください...',
        submitButton: 'お問い合わせを送信',
        submitting: '送信中...',
        successTitle: '送信成功',
        successDescription: 'お問い合わせを受け付けました。24時間以内にご連絡いたします。',
        serviceOptions: {
          digitalTwin: 'デジタルツイン＆グローバルミラー運営',
          verticalStrategy: '垂直領域戦略浸透',
          crossDomain: 'クロスドメイン運営＆コンプライアンス管理',
          other: 'その他のコンサルティングサービス',
        },
        validation: {
          nameMin: '氏名は2文字以上である必要があります',
          companyMin: '会社名は2文字以上である必要があります',
          emailInvalid: '有効なメールアドレスを入力してください',
          phoneMin: '有効な電話番号を入力してください',
          serviceTypeRequired: 'サービスタイプを選択してください',
          messageMin: 'メッセージは10文字以上である必要があります',
        },
      },
      info: {
        title: '連絡先情報',
        office: 'ドバイオフィス',
        phone: '電話番号',
        email: 'メールアドレス',
        hours: '営業時間',
        hoursContent: '月曜日 - 金曜日: 9:00 - 18:00 (GST)\n土曜日 - 日曜日: 予約制',
        followUs: 'フォローする',
        mapTitle: 'オフィス所在地',
        mapDescription: 'Mazaya Business Avenue BB2 - Jumeirah Lakes Towers (JLT), Dubai',
      },
      cta: {
        title: '国境を越えた旅を始める準備はできましたか？',
        description: 'デジタルツインソリューション、垂直領域戦略コンサルティング、またはクロスドメイン運営とコンプライアンス管理をお探しの場合、SHONCHIN MANOR & CO. は専門的で信頼性の高いワンストップソリューションを提供します。',
        bookButton: 'コンサルティング予約',
        downloadButton: 'サービスパンフレットをダウンロード',
      },
    },
  },
  'ko': {
    nav: {
      home: '홈',
      about: '회사 소개',
      services: '서비스',
      advisory: '자문위원회',
      news: '회사 소식',
      cases: '성공 사례',
      contact: '문의하기',
    },
    home: {
      hero: {
        title: '인월쌍청 전세기업',
        subtitle: 'SHONCHIN MANOR & CO.',
        description: '아시아 기업을 위해 UAE에서 디지털 트윈 미러 엔티티를 구축하여 글로벌 운영 및 자산 보호를 실현합니다.',
        cta: '문의하기',
        learnMore: '자세히 보기',
      },
      stats: {
        title: '핵심 강점',
        subtitle: '중국-아랍 국경 간 비즈니스 컨설팅 15년 경력, 200개 이상의 중국 기업에 서비스 제공',
        clients: '서비스 기업',
        assets: '자산 관리 규모',
        success: '성공률',
        countries: '국가 커버리지',
      },
      services: {
        title: '핵심 서비스',
        subtitle: '4개의 핵심 비즈니스 부문으로 포괄적인 국경 간 비즈니스 컨설팅 서비스 제공',
        viewAll: '모든 서비스 보기',
      },
      trust: {
        title: '신뢰 인증',
        subtitle: '국제 권위 기관의 인증을 받은 신뢰할 수 있는 국경 간 비즈니스 파트너',
        dmcc: 'DMCC 공식 ISP',
        dmccDesc: '국제 서비스 제공업체 자격',
        difc: 'DIFC 인증',
        difcDesc: '금융 센터 인증',
        iso: 'ISO 9001',
        isoDesc: '품질 관리 시스템',
        aml: 'AML 규정 준수',
        amlDesc: '자금 세탁 방지 인증',
      },
      cta: {
        title: '글로벌 여정을 시작하세요',
        description: '해외 시장 확장을 추구하는 기업이든 자산 보호가 필요한 가족이든, 쌍청 팀은 전문적이고 신뢰할 수 있는 국경 간 비즈니스 컨설팅 서비스를 제공합니다.',
        button: '상담 예약',
      },
      about: {
        title: '백년의 지혜,',
        titleHighlight: '디지털 주권 구축',
        description: '1897년 쌍청루의 유산에 뿌리를 두고, UAE에서 아시아 기업을 위한 디지털 트윈 엔티티를 구축하여 글로벌 운영과 자산 보호를 실현합니다.',
        learnMore: '자세히 보기',
        stat1Value: '2K+',
        stat1Label: '서비스 사례',
        stat2Value: '3K+',
        stat2Label: '규정 준수 엔티티',
        stat3Value: '10+',
        stat3Label: '수직 영역',
      },
      servicesSection: {
        badge: '핵심 서비스',
        title: '국경 간 디지털 주권 솔루션',
        learnDetail: '자세히 보기',
      },
      whySection: {
        title: '왜 쌍청을 선택해야 할까요?',
        item1Title: 'DMCC 공식 ISP',
        item1Desc: '두바이 다목적 상품 센터 공식 인증 국제 서비스 제공업체, 원격 규정 준수 설립 특권 보유',
        item2Title: '백년 전통 계승',
        item2Desc: '1897년 쌍청루의 역사적 유산에 뿌리를 두고 혁명 정신과 고결한 품격을 계승',
        item3Title: '전체 체인 서비스',
        item3Desc: '엔티티 설립부터 비즈니스 구현까지 엔드투엔드 전략 컨설팅 및 실행 서비스',
      },
      teamSection: {
        title: '전문 팀',
      },
      teamMembers: {
        founderCeo: { displayName: '廖怀南 (Aaron Liao)', position: '창업자 & CEO' },
        partnerCfo: { displayName: '钟茜 (Grace Zhong)', position: '파트너 & CFO' },
        partnerClo: { displayName: '付慧中 (Selena Fu)', position: '파트너 & CLO' },
      },
      partners: {
        item1: '두바이 비즈니스 센터',
        item2: 'UAE 정부 인증',
      },
    },
    footer: {
      description: '1897년 "쌍청루" 역사적 유산에 뿌리를 두고 중국-아랍 국경 간 디지털 주권 및 가족 사업 승계 서비스 전문.',
      slogan: '인월쌍청 전세기업',
      quickLinks: '빠른 링크',
      coreServices: '핵심 서비스',
      contact: '연락처',
      dubai: '두바이 사무소',
      china: '중국 사무소',
      email: '이메일',
      copyright: '© 2026 SHONCHIN MANOR & CO. All Rights Reserved',
      privacy: '개인정보 처리방침',
      terms: '서비스 약관',
      compliance: '규정 준수',
    },
    // 회사 소개 페이지（한국어）
    about: {
      badge: '회사 소개',
      hero: {
        title: '인월쌍청 전세기업',
        subtitle: '백년의 지혜를 계승하여 중국 기업의 국경 간 디지털 주권 구축',
      },
      values: {
        history: {
          title: '역사적 계승',
          description: '1897년 쌍청루의 백년 지혜를 계승하여 랴오중카이, 허샹닝 선생의 혁명 정신과 고결한 품격을 현대 비즈니스 서비스에 융합시켰습니다.',
        },
        integrity: {
          title: '전문적 성실',
          description: '"매화의 청"의 직업 윤리를 고수하여 고객에게 규정 준수, 투명하고 신뢰할 수 있는 국경 간 비즈니스 컨설팅 서비스를 제공합니다.',
        },
        innovation: {
          title: '혁신적 서비스',
          description: '디지털 트윈, 원격 규정 준수 등 혁신 기술을 활용하여 중국 기업의 글로벌 운영을 위한 새로운 패러다임을 구축합니다.',
        },
        collaboration: {
          title: '국경 간 협력',
          description: '중국-아랍 비즈니스 생태계를 깊이 가꾸며, 자유 구역과 본토 시장 장벽을 허물어 진정한 국경 간 협력 운영을 실현합니다.',
        },
      },
      story: {
        badge: '브랜드 스토리',
        title: '쌍청루의',
        titleHighlight: '백년 유산',
        year: '쌍청루 설립',
        paragraph1: '1897년 랴오중카이, 허샹닝 선생이 광저우에 "쌍청루"를 설립했습니다. "달의 청"과 "매화의 청"에서 이름을 따서, 거시적 통찰력과 고결한 품격의 이중 순수함을 상징합니다.',
        paragraph2: 'SHONCHIN MANOR & CO.의 브랜드 이름은 "쌍청"의 광둥어 발음(Shon Chin)에서 유래하며, Manor는 가족 유산의 계승과 보호를 상징합니다. 선조의 혁명 정신을 현대 비즈니스 서비스의 핵심 가치로 전환하여 글로벌화의 물결 속에서 중국 기업의 디지털 주권을 구축합니다.',
        paragraph3: '1897년 쌍청루에서 2026년 두바이 DMCC까지, 백년의 지혜 계승을 넘어 항상 "인월쌍청"의 이념을 고수합니다——달의 청의 거시적 비전으로 글로벌 비즈니스 환경을 통찰하고, 매화의 청의 직업 윤리로 고객의 영속적인 사업을 수호합니다.',
      },
      philosophy: {
        title: '이중 순수함의',
        titleHighlight: '기업 이념',
        subtitle: '달의 청의 거시적 통찰력 × 매화의 청의 직업 윤리',
        moon: {
          title: '달의 청',
          description: '높이 빛나는 달처럼 전체를 조감합니다. 거시적 시각으로 글로벌 비즈니스 환경을 통찰하고 고객에게 전략적 계획과 국경 간 레이아웃 솔루션을 제공합니다.',
          point1: '중국-아랍 비즈니스 생태계와 정책 규정에 대한 심층 연구',
          point2: '게임, AI, Web3 등 수직 영역의 트렌드를 선제적으로 파악',
          point3: '글로벌 시각에서 국경 간 운영 전략 구축',
        },
        plum: {
          title: '매화의 청',
          description: '혹한 속에서도 자랑스럽게 피는 매화처럼 성실함을 지킵니다. 고결한 직업 윤리로 규정 준수, 투명하고 신뢰할 수 있는 전문 서비스를 제공합니다.',
          point1: '국제 자금 세탁 방지 및 규정 준수 기준의 엄격 준수',
          point2: '투명한 서비스 프로세스로 고객 개인정보 보호',
          point3: '장기적 가치관으로 고객의 영속적인 사업 수호',
        },
      },
      team: {
        badge: '핵심 팀',
        title: '전문 팀',
        subtitle: '중국-아랍 국경 간 비즈니스 정예를 모아 전문 서비스를 제공합니다',
      },
      founderQuote: {
        badge: '창업자 메시지',
        paragraph1: 'SHONCHIN MANOR의 창업자로서, 오늘날 복잡한 글로벌 경제 환경 속에서 지역 간 협력은 단순한 자본의 흐름을 훨씬 넘어서며, 문화와 전략의 깊은 융합이 핵심임을 깊이 인식하고 있습니다. 미디어 엔터테인먼트와 첨단 기술 분야에서 쌓은 풍부한 경험을 바탕으로, SHONCHIN MANOR를 탁월한 전략 컨설팅 및 자원 통합 플랫폼으로 구축하는 데 전념하고 있습니다.',
        paragraph2: '우리의 사명은 명확합니다. UAE에 뿌리를 두고 아시아를 향해, 정밀한 산업 통찰과 자원 배치를 통해 양측 기업이 문화와 시장의 장벽을 극복하도록 지원합니다. 가족으로부터 전수된 가치관과 현대 비즈니스의 혁신적 동력을 융합함으로써, 아시아와 중동의 협력·공영의 새로운 장을 열고 전 세계 엘리트 파트너들에게 진정한 장기적 가치를 창출할 수 있다고 굳게 믿습니다.',
      },
    },
    // 核心服务页面（韩语）
    servicesPage: {
      badge: '핵심 서비스',
      hero: {
        title: '국경 간 디지털 주권',
        titleLine2: '엔드투엔드 솔루션',
        subtitle: '1897년 설립된 쌍청루의 백년 전통을 바탕으로 중국 기업에게 UAE 디지털 트윈 엔티티 설립, 수직 영역 전략 침투 및 국경 간 규정 준수 운영의 원스톱 서비스를 제공합니다',
      },
      benefitsTitle: '핵심 이점',
      whyChoose: {
        title: '왜 쌍청을 선택해야 할까요?',
        reason1: {
          title: 'DMCC 공식 ISP 자격',
          description: '두바이 다목적 상품 센터 공식 인증 국제 서비스 제공업체로서 원격 규정 준수 설립 특권을 누리며 고객에게 가장 효율적인 서비스 채널을 제공합니다',
        },
        reason2: {
          title: '백년 전통 계승',
          description: '1897년 쌍청루의 역사적 유산에 뿌리를 두고 랴오중카이, 허샹닝 선생의 혁명 정신과 고결한 품격을 계승하며, 달의 청명함의 거시적 통찰력과 매화의 청명함의 직업 윤리로 고객에게 서비스를 제공합니다',
        },
        reason3: {
          title: '수직 영역 전문성',
          description: '게임 e스포츠, RWA 토큰화, AI 컴퓨팅 파워의 세 가지 수직 영역에 집중하여 엔티티 설립부터 비즈니스 구현까지 엔드투엔드 전략 컨설팅 및 실행 서비스를 제공합니다',
        },
        reason4: {
          title: '완전 원격 규정 준수',
          description: '혁신적인 디지털 트윈 서비스 모델을 통해 고객은 두바이를 방문하지 않고도 엔티티 설립 및 운영 관리를 완료할 수 있어 시간 비용과 출장 비용을 크게 절감합니다',
        },
      },
      cta: {
        title: '국경 간 여정을 시작하세요',
        description: '해외 시장 확장을 추구하는 기업이든 자산 보호가 필요한 가족이든, 쌍청 팀은 가장 전문적인 국경 간 비즈니스 컨설팅 서비스를 제공합니다',
        button: '지금 문의하기',
      },
    },
    services: {
      digitalTwin: {
        title: '디지털 트윈 및 글로벌 미러 운영',
        description: '두바이 DMCC 공식 국제 서비스 제공업체(ISP)로서 중국 기업을 위한 원격 규정 준수 디지털 트윈 엔티티 설립 서비스를 제공하여 출장 없이 물리적 존재 없이 글로벌 운영을 가능하게 합니다.',
        features: '주요 기능',
        benefits: '핵심 이점',
      },
      verticalStrategy: {
        title: '수직 영역 전략 침투',
        description: '게임 e스포츠, RWA 토큰화, AI 컴퓨팅 파워의 세 가지 수직 영역에 초점을 맞춰 엔티티 설립부터 비즈니스 구현까지 엔드투엔드 전략 컨설팅 및 실행 서비스를 제공합니다.',
        features: '주요 기능',
        benefits: '핵심 이점',
      },
      crossDomain: {
        title: '크로스 도메인 운영 및 규정 준수 관리',
        description: 'Resolution No.11 규정을 기반으로 기업이 자유 구역과 본토 시장 장벽을 연결하고 두바이 본토 비즈니스 확장 및 국경 간 규정 준수 운영을 실현하도록 지원합니다.',
        features: '주요 기능',
        benefits: '핵심 이점',
      },
    },
    contactPage: {
      hero: {
        title: '문의하기',
        subtitle: '국경 간 디지털 주권 여정을 시작하세요',
      },
      form: {
        title: '정보를 남겨주세요',
        description: '아래 양식을 작성해 주시면 전문 컨설턴트가 24시간 내에 연락하여 맞춤형 국경 간 비즈니스 컨설팅 솔루션을 제공합니다.',
        nameLabel: '이름',
        namePlaceholder: '이름을 입력하세요',
        companyLabel: '회사명',
        companyPlaceholder: '회사명을 입력하세요',
        emailLabel: '이메일',
        emailPlaceholder: 'your@email.com',
        phoneLabel: '전화번호',
        phonePlaceholder: '+971 4 XXX XXXX',
        serviceTypeLabel: '서비스 유형',
        serviceTypePlaceholder: '관심 있는 서비스를 선택하세요',
        messageLabel: '메시지',
        messagePlaceholder: '요구 사항이나 질문을 자세히 설명해 주세요...',
        submitButton: '문의 제출',
        submitting: '제출 중...',
        successTitle: '제출 성공',
        successDescription: '문의를 받았습니다. 24시간 내에 연락드리겠습니다.',
        serviceOptions: {
          digitalTwin: '디지털 트윈 및 글로벌 미러 운영',
          verticalStrategy: '수직 영역 전략 침투',
          crossDomain: '크로스 도메인 운영 및 규정 준수 관리',
          other: '기타 컨설팅 서비스',
        },
        validation: {
          nameMin: '이름은 최소 2자 이상이어야 합니다',
          companyMin: '회사명은 최소 2자 이상이어야 합니다',
          emailInvalid: '유효한 이메일 주소를 입력하세요',
          phoneMin: '유효한 전화번호를 입력하세요',
          serviceTypeRequired: '서비스 유형을 선택하세요',
          messageMin: '메시지는 최소 10자 이상이어야 합니다',
        },
      },
      info: {
        title: '연락처 정보',
        office: '두바이 사무소',
        phone: '전화번호',
        email: '이메일',
        hours: '영업 시간',
        hoursContent: '월요일 - 금요일: 9:00 - 18:00 (GST)\n토요일 - 일요일: 예약제',
        followUs: '팔로우하기',
        mapTitle: '사무소 위치',
        mapDescription: 'Mazaya Business Avenue BB2 - Jumeirah Lakes Towers (JLT), Dubai',
      },
      cta: {
        title: '국경 간 여정을 시작할 준비가 되셨나요?',
        description: '디지털 트윈 솔루션, 수직 영역 전략 컨설팅 또는 크로스 도메인 운영 및 규정 준수 관리를 찾고 계신다면 SHONCHIN MANOR & CO.가 전문적이고 신뢰할 수 있는 원스톱 솔루션을 제공합니다.',
        bookButton: '컨설팅 예약',
        downloadButton: '서비스 브로셔 다운로드',
      },
    },
  },
} as const;

export type Language = keyof typeof translations;
export type TranslationKey = keyof typeof translations['zh-CN'];